module.exports = __webpack_public_path__ + "img/tianmaotigongfapiao.52ba05af.png";